module.exports = __webpack_public_path__ + "static/media/05-13.ac0c7c57.png";